import { KpiMetric } from './kpi-metric'
import { KpiMetricQuery } from './kpi-metric-query'
import { KpiMetricMutation } from './kpi-metric-mutation'

export const entities = [KpiMetric]
export const resolvers = [KpiMetricQuery, KpiMetricMutation]
export const subscribers = []
